import { Bookmark, Loader2, Play } from 'lucide-react';

// Quick-execute chip strip for saved order templates.
export default function TemplateChips({ templates, isAr, connectedCount, executingId, onExecute }) {
  if (!templates?.length) return null;
  return (
    <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-3">
      <div className="flex items-center gap-2 mb-2">
        <Bookmark className="h-3.5 w-3.5 text-[#d4af37]" />
        <span className="text-[11px] font-bold text-white/70">
          {isAr ? 'قوالب سريعة' : 'Quick templates'}
        </span>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {templates.map((t) => (
          <button
            key={t.id}
            onClick={() => onExecute(t)}
            disabled={executingId === t.id || connectedCount === 0}
            className="group inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-[11px] font-bold border transition disabled:opacity-40 hover:opacity-100"
            style={{
              background: `${t.color || '#d4af37'}22`,
              borderColor: `${t.color || '#d4af37'}55`,
              color: t.color || '#d4af37',
            }}
            data-testid={`tpl-chip-${t.id}`}
            title={`${t.symbol} · ${t.mode} · lot ${t.volume}`}
          >
            {executingId === t.id
              ? <Loader2 className="h-3 w-3 animate-spin" />
              : <Play className="h-3 w-3" />}
            <span>{t.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
